module.exports = __webpack_public_path__ + "img/digital_signage-w.svg";